/**
 * 환경별 base URL을 반환하는 유틸리티 함수
 * @returns {string} 환경에 맞는 base URL
 */
export function getBaseUrl(): string {
  // 서버에서 실행될 때 (NEXT_PUBLIC_ 접두사 없음)
  if (typeof window === 'undefined') {
    return (
      process.env.BASE_URL ||
      process.env.NEXT_PUBLIC_BASE_URL ||
      'http://localhost:3000'
    );
  }

  // 클라이언트에서는 현재 도메인을 우선 사용하여 잘못된 로컬 기본값을 방지
  const envBaseUrl = process.env.NEXT_PUBLIC_BASE_URL;
  if (envBaseUrl && !envBaseUrl.includes('localhost')) {
    return envBaseUrl;
  }

  return window.location.origin;
}

/**
 * API 엔드포인트 URL을 생성하는 유틸리티 함수
 * @param endpoint - API 엔드포인트 경로 (예: 'announcements', 'notices/123')
 * @returns {string} 완전한 API URL
 */
export function getApiUrl(endpoint: string): string {
  const baseUrl = getBaseUrl();
  return `${baseUrl}/api/${endpoint}`;
}
